import { render, staticRenderFns } from "./InformacionActuacion.vue?vue&type=template&id=0d4bf7b8"
import script from "./InformacionActuacion.vue?vue&type=script&lang=js"
export * from "./InformacionActuacion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports